var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 33,
    viewBox: "0 0 44 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16663 1H42.8333V32H1.16663V1Z",
    fill: "white",
    stroke: "#000000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1111 11.3758H33.6682C32.485 11.3758 31.526 10.6564 31.526 9.76903V8.55742H40.2535V9.76903C40.2535 10.6564 39.2943 11.3758 38.1111 11.3758Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3237 11.3758H5.88085C4.6976 11.3758 3.73853 10.6564 3.73853 9.76903V8.55742H12.466V9.76903C12.466 10.6564 11.5068 11.3758 10.3237 11.3758Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7165 11.3758H18.2492L16.5386 6.58159H27.4271L25.7165 11.3758Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9758 5.82571C24.628 6.83883 22.0437 6.53902 22.0437 6.53902C22.0437 6.53902 21.6448 4.59652 22.9926 3.58339C24.3405 2.5702 26.9248 2.87007 26.9248 2.87007C26.9248 2.87007 27.3237 4.81259 25.9758 5.82571Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0051 5.82571C19.3531 6.83883 21.9372 6.53902 21.9372 6.53902C21.9372 6.53902 22.3363 4.59652 20.9883 3.58339C19.6404 2.5702 17.0561 2.87007 17.0561 2.87007C17.0561 2.87007 16.6572 4.81259 18.0051 5.82571Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3125 16.5981L39.0976 30.1696H36.9166L33.776 16.5973",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72363 16.5971L4.93848 30.1696H7.11939L10.2626 16.5864",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9136 16.5709L34.5587 21.0133",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43848 21.0133L19.0871 16.5691",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2219 16.5297H5.77068C4.01325 16.5297 2.5885 15.4611 2.5885 14.143V11.3767H41.404V14.143C41.404 15.4611 39.9792 16.5297 38.2219 16.5297Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.48853 11.3758H42.4885",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.856011b5ef6cdb87150d5f5be61fb957.svg";
export { ForwardRef as ReactComponent };